/// <reference types="vite/client" />

import { render } from "phase.ts";

import { App } from "./components/App";

window.addEventListener("load", () =>
  navigator.serviceWorker.register(
    import.meta.env.PROD
      ? "./service-worker.js"
      : new URL("./service-worker", import.meta.url),
    { type: "module" },
  ),
);

render(App, document.body);
